module.exports = __webpack_public_path__ + "img/arrow-right.dc372a07.svg";